import generate from 'nanoid/generate';

const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const lowercase = 'abcdefghijklmnopqrstuvwxyz';
const numbers = '0123456789';
const idDictionary = `${uppercase}${lowercase}${numbers}`;

export const generateId = (size: number): string => generate(idDictionary, size);
